/**
 * Accua Cookie Consent JavaScript
 * 
 * This script handles all client-side functionality for the Accua Cookie Consent plugin.
 * It manages cookie consent preferences, displays/hides consent dialogs, and controls
 * loading of blocked content based on user consent decisions.
 * 
 * @since 1.0.0
 */
(function ($) {
    'use strict';

    /**
     * Main Accua Cookie Consent handler
     * 
     * @namespace accuaCookieConsent
     */
    const accuaCookieConsent = {
        // Store user preferences
        preferences: {},
        denied: [],
        accepted: [],

        /**
         * Initialize the cookie consent functionality
         * 
         * @function init
         * @memberof accuaCookieConsent
         */
        init: function () {
            // Get data from localized script
            this.data = accua_cookie_data;
            this.currentCookieValue = this.getCookie();

            // Setup event listeners
            this.setupEventListeners();

            // Initialize UI based on cookie state
            this.initializeUI();
        },

        /**
         * Setup all event listeners
         * 
         * @function setupEventListeners
         * @memberof accuaCookieConsent
         */
        setupEventListeners: function () {
            const self = this;

            // Accept button click
            $('#accua_cookie_btn, .accua-cookie').on('click', function (e) {
                e.preventDefault();

                // Use setTimeout to ensure DOM is ready and checkboxes are available
                setTimeout(function () {
                    // Check all checkboxes
                    $(".accua_cookie_wrapper input[type='checkbox']").prop('checked', true);

                    // Process the consent
                    self.processConsent(true, "");
                }, 50);
                $("#overlay-plugin-accua").hide();
            });

            // Update button click
            $('.accua_cookie_btn_update, .accua-cookie').on('click', function (e) {
                $('.update-message-box').show();
                self.processConsent(true, $(this).closest(".accua_cookie_box")[0]);
                setTimeout(function () {
                    $('.update-message-box').hide();
                }, 6000);
            });

            // Decline button click
            $('#accua_cookie_btn_decline').on('click', function () {
                self.processConsent(true, "");
                $("#overlay-plugin-accua").hide();
            });

            // Close (X) button click
            $('#cookie_consent_close_x').on('click', function () {
                $('#accua_cookie_btn_decline').click();
            });

            // Show cookie dialog via shortcode (use event delegation for dynamically added elements)
            $(document).on('click', '.showdialog-shortcode', function (e) {
                e.preventDefault();
                
                // Check if using centered accessible modal
                if (typeof window.AccuaAccessibleModal !== 'undefined' && window.AccuaAccessibleModal.open) {
                    // Clear any inline display style first (may have been set by close)
                    $(".accua_cookie_wrapper").css('display', '');
                    window.AccuaAccessibleModal.open();
                } else {
                    $(".accua_cookie_wrapper").fadeIn("slow");
                }
            });

            // Floating cookie icon click handler
            $(document).on('click', '.accua-cookie-floating-icon', function (e) {
                e.preventDefault();
                
                // Check if using accessible modal
                if (typeof window.AccuaAccessibleModal !== 'undefined' && window.AccuaAccessibleModal.open) {
                    $(".accua_cookie_wrapper").css('display', '');
                    window.AccuaAccessibleModal.open();
                } else {
                    $(".accua_cookie_wrapper").fadeIn("slow");
                }
            });

            // Handle "More Info" link clicks
            $(".fom").click(function (event) {
                if ($(this).attr('href') === '#') {
                    $(".accua_cookie_more_info_popover_generic").fadeIn("slow");
                    $("#obfuscator").fadeIn("fast");
                    window.scrollTo(0, 0);
                    event.preventDefault();
                }
            });

            // Close generic info popover
            $("#accua_close, #accua_close_x").click(function () {
                self.closeMoreInfoGeneric();
            });
        },

        /**
         * Initialize UI elements based on current cookie state
         * 
         * @function initializeUI
         * @memberof accuaCookieConsent
         */
        initializeUI: function () {
            const self = this;

            // Apply position classes
            this.applyPositionClasses();

            // Initialize floating cookie icon
            this.initFloatingIcon();

            // Check if cookie exists and is not empty
            if (this.currentCookieValue !== null && this.currentCookieValue !== "") {
                this.updateButtonText(this.data.buttonUpdateText);
                this.loadExistingPreferences();
            } else {
                // First visit or cookie deleted
                this.showBlockedContent();
                this.updateButtonText(this.data.buttonAcceptText);
                
                // Skip showing wrapper for centered - handled by scripts-a11y.js
                if (this.data.position !== 'centered') {
                    $(".accua_cookie_wrapper").show();
                    $("#overlay-plugin-gdpr").show();
                }
            }

            // Setup description handlers for all cookie classes
            $.each(this.data.classesData, function (k, v) {
                self.setCloseDescriptionHandler(v.name);
                self.setOpenDescriptionHandler(v.name);
            });
        },

        /**
         * Initialize the floating cookie icon
         * Handles visibility based on consent state and responsive positioning
         * 
         * @function initFloatingIcon
         * @memberof accuaCookieConsent
         */
        initFloatingIcon: function () {
            const self = this;
            const $icon = $('.accua-cookie-floating-icon');
            
            if (!$icon.length) {
                return; // Icon not present on page
            }

            // Get visibility setting from data attribute
            const visibility = $icon.data('visibility') || 'always';
            const cookieExists = this.currentCookieValue !== null && this.currentCookieValue !== "";

            // Determine if icon should be shown based on visibility setting
            if (visibility === 'after_consent' && !cookieExists) {
                $icon.addClass('accua-cookie-floating-icon--hidden');
            }

            // Setup responsive positioning
            this.updateFloatingIconPosition();
            $(window).on('resize', function () {
                self.updateFloatingIconPosition();
            });
        },

        /**
         * Update floating icon position based on current viewport width
         * Reads responsive settings from data attributes
         * 
         * @function updateFloatingIconPosition
         * @memberof accuaCookieConsent
         */
        updateFloatingIconPosition: function () {
            const $icon = $('.accua-cookie-floating-icon');
            
            if (!$icon.length) {
                return;
            }

            const windowWidth = $(window).width();
            const breakpointTablet = parseInt($icon.data('breakpoint-tablet') || 1024, 10);
            const breakpointMobile = parseInt($icon.data('breakpoint-mobile') || 480, 10);

            // Determine current device type
            let device = 'desktop';
            if (windowWidth <= breakpointMobile) {
                device = 'mobile';
            } else if (windowWidth <= breakpointTablet) {
                device = 'tablet';
            }

            // Check if icon is enabled for this device
            const isEnabled = $icon.data(device + '-enabled') !== '0';
            const side = $icon.data(device + '-side') || 'right';

            // Toggle hidden state based on device enablement
            if (!isEnabled) {
                $icon.addClass('accua-cookie-floating-icon--device-hidden');
            } else {
                $icon.removeClass('accua-cookie-floating-icon--device-hidden');
            }

            // Update position class
            $icon.removeClass('accua-cookie-floating-icon--left accua-cookie-floating-icon--right');
            $icon.addClass('accua-cookie-floating-icon--' + side);
        },

        /**
         * Show the floating icon (called after consent is given)
         * 
         * @function showFloatingIcon
         * @memberof accuaCookieConsent
         */
        showFloatingIcon: function () {
            const $icon = $('.accua-cookie-floating-icon');
            if ($icon.length && $icon.data('visibility') === 'after_consent') {
                $icon.removeClass('accua-cookie-floating-icon--hidden');
            }
        },

        /**
         * Hide the floating icon when modal is open
         * 
         * @function hideFloatingIcon
         * @memberof accuaCookieConsent
         */
        hideFloatingIcon: function () {
            $('.accua-cookie-floating-icon').addClass('accua-cookie-floating-icon--hidden');
        },

        /**
         * Update the text on consent buttons
         * 
         * @function updateButtonText
         * @memberof accuaCookieConsent
         * @param {string} text - Text to display on buttons
         */
        updateButtonText: function (text) {
            $(".accua_cookie_btn_update").each(function () {
                $(this).text(text);
            });
        },

        /**
         * Apply position classes to elements
         * 
         * @function applyPositionClasses
         * @memberof accuaCookieConsent
         */
        applyPositionClasses: function () {
            const self = this;

            $.each(this.data.positionClasses, function (k, v) {
                if (v.active) {
                    $(v.position).each(function () {
                        if (self.data.classesData[v.class] !== undefined) {
                            $(this).after(
                                '<span class="blockedContent-' + v.class + '">' +
                                self.data.blockedMessage.replace("{category}",
                                    self.data.classesData[v.class].label) + '</span>'
                            );
                        }
                    });
                }
            });
        },

        /**
         * Load existing preferences from cookie
         * 
         * @function loadExistingPreferences
         * @memberof accuaCookieConsent
         */
        loadExistingPreferences: function () {
            const self = this;

            // Split cookie value by pipe character
            const cookieSettings = this.currentCookieValue.split('|');

            // Process each setting — use category name for lookups/selectors
            $.each(cookieSettings, function (k, v) {
                const setting = v.split(':');
                const catKey = setting[0];
                // Look up by key; also try finding by name field for robustness
                var catData = self.data.classesData[catKey];
                if (typeof catData === 'undefined') {
                    // Fallback: search classesData entries by name field
                    $.each(self.data.classesData, function (dk, dv) {
                        if (dv.name === catKey) {
                            catData = dv;
                            return false; // break
                        }
                    });
                }
                if (typeof catData !== 'undefined') {
                    var catName = catData.name;
                    if (setting[1] === 'set') {
                        self.preferences[catName] = true;
                        self.accepted.push(catName);
                        $(".checkbox-" + catName).prop('checked', true);
                    } else {
                        self.preferences[catName] = false;
                        self.denied.push(catName);
                        $(".checkbox-" + catName).prop('checked', false);
                    }
                }
            });

            // Check for new cookie classes since user's last consent
            let newSettings = false;
            $.each(this.data.classesData, function (k, v) {
                if (typeof self.preferences[v.name] === 'undefined') {
                    newSettings = true;
                }
            });

            if (newSettings) {
                // Show consent dialog for new settings
                this.showBlockedContent();
                
                // Skip showing wrapper for centered - handled by scripts-modal.js
                if (this.data.position !== 'centered') {
                    $(".accua_cookie_wrapper").show();
                    $("#overlay-plugin-accua").show();
                } else if (typeof window.AccuaAccessibleModal !== 'undefined') {
                    // For centered, trigger the accessible modal
                    window.AccuaAccessibleModal.open();
                }
            } else {
                // Apply existing preferences
                this.activateBlockedElements(this.denied, this.accepted);
            }
        },

        /**
         * Show all blocked content
         * 
         * @function showBlockedContent
         * @memberof accuaCookieConsent
         */
        showBlockedContent: function () {
            const self = this;

            $.each(this.data.classesData, function (k, v) {
                $(".blockedContent-" + v.name).show();
            });
        },

        /**
         * Close the "More Info" generic popup
         * 
         * @function closeMoreInfoGeneric
         * @memberof accuaCookieConsent
         */
        closeMoreInfoGeneric: function () {
            $("#obfuscator").fadeOut("fast");
            $(".accua_cookie_more_info_popover_generic").fadeOut("slow");
        },

        /**
         * Set handler for closing cookie class description
         * 
         * @function setCloseDescriptionHandler
         * @memberof accuaCookieConsent
         * @param {string} name - Cookie class name
         */
        setCloseDescriptionHandler: function (name) {
            $("#accua_close_" + name + ", #accua_close_x_" + name).click(function () {
                $("#obfuscator").fadeOut("fast");
                $(".description_popover_" + name).fadeOut("slow");
            });
        },

        /**
         * Set handler for opening cookie class description
         * 
         * @function setOpenDescriptionHandler
         * @memberof accuaCookieConsent
         * @param {string} name - Cookie class name
         */
        setOpenDescriptionHandler: function (name) {
            $(".accua_open_" + name).click(function () {
                $(".description_popover_" + name).fadeIn("slow");
                $("#obfuscator").fadeIn("fast");
                window.scrollTo(0, 0);
            });
        },

        /**
         * Get all cookie names currently set in the browser
         * 
         * @function getAllBrowserCookieNames
         * @memberof accuaCookieConsent
         * @returns {Array} Array of cookie name strings
         */
        getAllBrowserCookieNames: function () {
            if (!document.cookie) return [];
            return document.cookie.split(';').map(function (c) {
                return c.trim().split('=')[0];
            });
        },

        /**
         * Delete cookies matching a pattern (supports * wildcards)
         * Converts pattern like "_ga_*" to a regex and matches against
         * all cookies currently in the browser.
         * 
         * @function deleteCookiesByPattern
         * @memberof accuaCookieConsent
         * @param {string} pattern - Cookie name or wildcard pattern
         */
        deleteCookiesByPattern: function (pattern) {
            const self = this;
            if (!pattern) return;

            // Escape regex special chars, then convert * wildcard to .*
            var regexStr = '^' + pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*') + '$';
            var regex = new RegExp(regexStr);

            var allCookies = this.getAllBrowserCookieNames();
            var apexDomain = /\.[^.]+\.[^.]+$/i.exec(window.location.hostname);

            $.each(allCookies, function (i, name) {
                if (regex.test(name)) {
                    // Delete with multiple path/domain combinations
                    self.setCookie(name, '', -1, '');
                    if (apexDomain) {
                        self.setCookie(name, '', -1, apexDomain[0]);
                    }
                }
            });
        },

        /**
         * Process user consent (accept or decline)
         * 
         * @function processConsent
         * @memberof accuaCookieConsent
         * @param {boolean} isApproved - Whether consent was approved
         * @param {HTMLElement|string} parent - Parent element or empty string
         */
        processConsent: function (isApproved, parent) {
            const self = this;

            // Save old preferences to detect revocations
            const oldPreferences = $.extend({}, this.preferences);
            const hadPreviousConsent = this.currentCookieValue !== null && this.currentCookieValue !== "";

            this.updateButtonText(this.data.buttonUpdateText);
            this.preferences = {};
            this.denied = [];
            this.accepted = [];

            const parentElement = parent === "" ? $(".accua_cookie_wrapper")[0] : parent;
            let hasRevocation = false;

            // Process each cookie class
            $.each(this.data.classesData, function (k, v) {
                const checkbox = $(".checkbox-" + v.name, parentElement)[0];
                if (checkbox != null) {
                    const isDenied = !checkbox.checked || (!isApproved && v.name !== "");
                    self.preferences[v.name] = !isDenied;

                    if (isDenied) {
                        self.denied.push(v.name);
                        // Delete cookies for denied categories (wildcard-aware)
                        if (v.cookies) {
                            var patterns = v.cookies.replace(/\s/g, '').split(';');
                            $.each(patterns, function (i, pat) {
                                if (pat) self.deleteCookiesByPattern(pat);
                            });
                        }
                        // Track if this was previously accepted (revocation)
                        if (hadPreviousConsent && oldPreferences[v.name] === true) {
                            hasRevocation = true;
                        }
                    } else {
                        self.accepted.push(v.name);
                    }
                }
            });

            this.createConsentCookie();
            this.currentCookieValue = this.getCookie();

            // If a previously-accepted category was revoked, reload the page
            // so PHP re-blocks the scripts from server side
            if (hasRevocation) {
                window.location.reload();
                return;
            }

            this.activateBlockedElements(this.denied, this.accepted);
        },

        /**
         * Create the consent cookie with user preferences
         * 
         * @function createConsentCookie
         * @memberof accuaCookieConsent
         */
        createConsentCookie: function () {
            const self = this;
            const value = [];

            $.each(this.preferences, function (k, v) {
                value.push(k + ":" + (v ? 'set' : 'no'));
            });

            const cookieValue = encodeURIComponent(value.join("|"));
            const expireDays = this.data.expireTimer > 0 ? this.data.expireTimer : 0;

            this.setCookie("accuaCookieConsent", cookieValue, expireDays, "");

            // centered modal is closed by scripts-modal.js, skip fadeOut
            if (this.data.position !== 'centered') {
                $(".accua_cookie_wrapper").fadeOut("fast");
                $("#overlay-plugin-accua").hide();
            }
        },

        /**
         * Set a cookie with the specified parameters
         * 
         * @function setCookie
         * @memberof accuaCookieConsent
         * @param {string} name - Cookie name
         * @param {string} value - Cookie value
         * @param {number} days - Days until expiration
         * @param {string} domain - Cookie domain
         */
        setCookie: function (name, value, days, domain) {
            let expires = "";

            if (days) {
                const date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }

            domain = domain ? ";domain=" + domain : "";
            document.cookie = name + "=" + value + expires + domain + ";path=/;SameSite=Lax";
        },

        /**
         * Get the Accua cookie consent value
         * 
         * @function getCookie
         * @memberof accuaCookieConsent
         * @returns {string|null} Cookie value or null if not found
         */
        getCookie: function () {
            const allCookies = document.cookie;

            if (allCookies === "") {
                return null;
            }

            const cookieList = allCookies.split("; ");
            for (let i = 0; i < cookieList.length; i++) {
                const cookie = cookieList[i];
                const separatorIndex = cookie.indexOf("=");
                const name = cookie.substring(0, separatorIndex);

                if (name === 'accuaCookieConsent') {
                    return decodeURIComponent(cookie.substring(separatorIndex + 1));
                }
            }

            return null;
        },

        /**
         * Delete the Accua cookie consent
         * 
         * @function deleteCookie
         * @memberof accuaCookieConsent
         */
        deleteCookie: function () {
            this.setCookie('accuaCookieConsent', '', -1, "");
        },

        /**
         * Reload JavaScript from a blocked script
         * 
         * @function reloadJs
         * @memberof accuaCookieConsent
         * @param {string} src - Script source
         */
        reloadJs: function (src) {
            const scriptSrc = $('script[data-blocked="' + src + '"]').attr("data-blocked");
            $('script[data-blocked="' + src + '"]').remove();
            $('<script/>').attr('src', scriptSrc).appendTo('body');
        },

        /**
         * Activate or deactivate blocked elements based on user consent
         * 
         * @function activateBlockedElements
         * @memberof accuaCookieConsent
         * @param {Array} denied - Array of denied cookie classes
         * @param {Array} accepted - Array of accepted cookie classes
         */
        activateBlockedElements: function (denied, accepted) {
            const self = this;

            // Show blocked content for denied classes
            $.each(denied, function (k, v) {
                $(".blockedContent-" + v).show();
                // Convert class names to selectors
                denied[k] = "." + v;
            });

            // Remove blocked content for accepted classes
            $.each(accepted, function (k, v) {
                $(".blockedContent-" + v).remove();
            });

            const deniedSelectors = denied.join(", ");

            // Reload blocked scripts that are now accepted
            $("script[data-blocked]").not(deniedSelectors).each(function () {
                self.reloadJs($(this).attr('data-blocked'));
            });

            // Unlock iframes, images, embeds and other elements blocked with 'data-blocked'
            $("body [data-blocked]").not("script").not(deniedSelectors).each(function () {
                var blockedUrl = $(this).attr('data-blocked');
                // <object> tags use 'data' attribute instead of 'src'
                var attrName = $(this).is('object') ? 'data' : 'src';
                $(this)
                    .attr(attrName, blockedUrl)
                    .removeAttr('data-blocked');
            });

            // Unlock embed scripts with 'type = text/blocked'
            // Use positive filter: only unblock scripts that have an explicit
            // accepted-category CSS class. This prevents unblocking classless
            // scripts (e.g. theme-hardcoded type="text/blocked" without a
            // category class) when some categories are denied.
            if (deniedSelectors === "") {
                // All categories accepted — safe to unblock everything
                $("script[type='text/blocked']").each(function () {
                    $(this).attr('type', 'text/javascript');
                    $.globalEval($(this).html());
                });
            } else {
                // Some categories denied — only unblock scripts with an
                // accepted category class
                var acceptedFilter = $.map(accepted, function (v) { return "." + v; }).join(", ");
                if (acceptedFilter) {
                    $("script[type='text/blocked']").filter(acceptedFilter).each(function () {
                        $(this).attr('type', 'text/javascript');
                        $.globalEval($(this).html());
                    });
                }
            }
        }
    };

    // Expose to global scope for use by modal
    window.AccuaCookieConsent = accuaCookieConsent;

    // Initialize on document ready
    $(document).ready(function () {
        accuaCookieConsent.init();
    });

})(jQuery);